import firebase from 'firebase/app';
import 'firebase/auth';

export default async function signOut(): Promise<void> {
  await firebase.auth().signOut();
}
